// src/pages/HomePage.js
import React, { useState, useEffect } from 'react';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Partners from '../components/Partners';
import ReportsSlider from '../components/ReportsSlider';
import BlogSection from '../components/BlogSection';
import FAQSection from '../components/FAQSection';
import Footer from '../components/Footer';
import './HomePage.css';

// Define your Strapi API URL
const API_URL = process.env.REACT_APP_STRAPI_URL || 'http://localhost:1337';

const HomePage = ({ posts }) => {
  const [faqs, setFaqs] = useState([]);
  const [loadingFaqs, setLoadingFaqs] = useState(true);
  const [faqError, setFaqError] = useState(null);

  useEffect(() => {
    const fetchFaqs = async () => {
      setLoadingFaqs(true);
      setFaqError(null);
      try {
        const response = await fetch(`${API_URL}/api/faqs?sort=displayOrder:asc`);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();

        if (result.data && Array.isArray(result.data)) {
          const formattedFaqs = result.data
            // Ensure question is a string and answer is present (will be a Markdown string)
            .filter(item => item && typeof item.question === 'string' && typeof item.answer === 'string')
            .map(item => {
              // 'item.answer' is now expected to be a Markdown string directly from Strapi
              // No JSON.parse() is needed.
              // console.log(`FAQ ID ${item.id} - Answer is Markdown string:`, item.answer); // Optional debug
              return {
                id: item.id,
                question: item.question,
                answer: item.answer, // Use the Markdown string answer directly
              };
            });
          setFaqs(formattedFaqs);

          // Check if any items were filtered out due to missing fields
          if (formattedFaqs.length < result.data.filter(i => i && i.question && i.answer).length) {
             console.warn("Some FAQ items might have been filtered out due to missing question or if the answer was not a string. Check Strapi data.");
          }

        } else {
          console.warn("API response did not contain 'result.data' as an array or 'result.data' is missing.", result);
          setFaqs([]);
        }
      } catch (error) {
        console.error("Failed to fetch FAQs:", error);
        setFaqError("Sorry, we couldn't load the FAQs at this time. Please try again later.");
      } finally {
        setLoadingFaqs(false);
      }
    };

    fetchFaqs();
  }, []); // Empty dependency array: runs once on mount

  return (
    <>
      <Hero />
      <Features />
      <Partners />
      <ReportsSlider />

      <section className="homePageBlogAreaWrapper">
        <div className="homePageBlogAreaHeader">
          <h2 className="homePageBlogAreaTitle">Latest news from Nexed Insights</h2>
          <p className="homePageBlogAreaSubtitle">
            Stay updated with our latest articles, research findings, and expert opinions.
          </p>
        </div>
        <BlogSection posts={posts} />
      </section>

      {/* FAQ Section Rendering (no changes needed here from last working version) */}
      {loadingFaqs && <div style={{textAlign: 'center', padding: '3rem 1rem'}}><p>Loading FAQs...</p></div>}
      {faqError && <div style={{textAlign: 'center', padding: '3rem 1rem', color: 'red'}}><p>{faqError}</p></div>}
      {!loadingFaqs && !faqError && faqs.length > 0 && <FAQSection faqs={faqs} />}
      {!loadingFaqs && !faqError && faqs.length === 0 && 
        (faqError ? null : <div style={{textAlign: 'center', padding: '3rem 1rem'}}><p>No frequently asked questions are available at the moment.</p></div>)
      }
      <Footer />
    </>
  );
};

export default HomePage;
